import SEOHead from "@/components/layout/SEOHead";
import { PageHero } from "@/pages/About.hero";
import { Link } from "react-router-dom";

/**
 * Reusable shell for content sub-pages.
 * Provides hero + a clean prose container, optional sidebar.
 */
export default function SimplePage({
  title,
  eyebrow,
  subtitle,
  description,
  path,
  children,
  ctaLabel = "Contact us",
  ctaTo = "/contact",
  aside,
}) {
  return (
    <>
      <SEOHead title={title} description={description || subtitle} path={path} />
      <PageHero eyebrow={eyebrow} title={title} subtitle={subtitle} />
      <section className="bg-white py-20 lg:py-28">
        <div className={`max-w-${aside ? "7xl" : "3xl"} mx-auto px-5 lg:px-10 ${aside ? "grid lg:grid-cols-12 gap-12" : ""}`}>
          <div className={aside ? "lg:col-span-8 prose-tiob" : "prose-tiob"}>
            {children}
            <div className="mt-10 not-prose flex flex-wrap gap-4">
              <Link to={ctaTo} className="btn-primary" data-testid="simplepage-cta">
                {ctaLabel}
              </Link>
            </div>
          </div>
          {aside && <aside className="lg:col-span-4">{aside}</aside>}
        </div>
      </section>
    </>
  );
}
